"use client";

import type { ReactNode } from "react";
import { Box } from "@mui/material";

type InfiniteScrollPageShellProps = {
  children: ReactNode;
  /** When true, apply the same horizontal inset used on Brain Hub. */
  inset?: boolean;
  /**
   * When true, allow the shell to span the full viewport width instead of
   * the default 90vw cap. Use for pages whose hero sections must bleed
   * edge-to-edge (e.g. the home landing page).
   */
  fullWidth?: boolean;
};

/**
 * Shared width/overflow shell for long-scroll pages (home, hub, etc.).
 * Matches Brain Hub layout constraints so the sticky navbar and page content
 * share the same viewport width behavior.
 */
export default function InfiniteScrollPageShell({
  children,
  inset = true,
  fullWidth = false,
}: InfiniteScrollPageShellProps) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: fullWidth ? "100%" : { xs: "100%", md: "90vw" },
        minWidth: 0,
        height: "100%",
        mx: "auto",
        mt: fullWidth ? 0 : 2,
        ...(inset ? { px: { xs: 1.5, sm: 2, md: 3 } } : {}),
        overflowX: "clip",
      }}
    >
      {children}
    </Box>
  );
}
